import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TitleIcon from '@mui/icons-material/Title';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import type { BlockType } from '../../types/nav';

interface Props {
  onAddBlock: (blockType: BlockType, title: string) => Promise<void>;
}

export default function AddBlockBar({ onAddBlock }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        mt: 3,
        pt: 2,
      }}
    >
      <Button
        size="small"
        variant="outlined"
        startIcon={<TitleIcon sx={{ fontSize: 14 }} />}
        onClick={() => onAddBlock('heading', 'New Heading')}
        sx={{
          fontSize: 13,
          fontWeight: 400,
          color: 'text.secondary',
          borderColor: 'divider',
          textTransform: 'none',
          '&:hover': {
            borderColor: 'text.secondary',
            bgcolor: 'action.hover',
          },
        }}
      >
        Heading
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={<HorizontalRuleIcon sx={{ fontSize: 14 }} />}
        onClick={() => onAddBlock('divider', '')}
        sx={{
          fontSize: 13,
          fontWeight: 400,
          color: 'text.secondary',
          borderColor: 'divider',
          textTransform: 'none',
          '&:hover': {
            borderColor: 'text.secondary',
            bgcolor: 'action.hover',
          },
        }}
      >
        Divider
      </Button>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ViewModuleIcon sx={{ fontSize: 14 }} />}
        onClick={() => onAddBlock('card-group', 'New Group')}
        sx={{
          fontSize: 13,
          fontWeight: 400,
          color: 'text.secondary',
          borderColor: 'divider',
          textTransform: 'none',
          '&:hover': {
            borderColor: 'text.secondary',
            bgcolor: 'action.hover',
          },
        }}
      >
        Card Group
      </Button>
    </Box>
  );
}
